export const compareByNumericName = (a, b) =>
  a.name.localeCompare(b.name, undefined, { numeric: true })
